import {useLatestQuery} from './queries/useLatestQuery'

export const useLatestData = () => {
  const {data: latest} = useLatestQuery()
  if (!latest) throw new Error('Latest plant data is not available')
  return latest
}
